// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__btgZ {
  height : 756px;
  width: 496px;
  max-height: 100vh;
  position: relative;
}

@media only screen and (max-width: 1023px) {
  .container__btgZ {
    height: 100vh;
    max-width: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/components/SalesFlowLocatorSearch.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  height : 756px;\n  width: 496px;\n  max-height: 100vh;\n  position: relative;\n}\n\n@media only screen and (max-width: 1023px) {\n  .container {\n    height: 100vh;\n    max-width: 100vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__btgZ`
};
export default ___CSS_LOADER_EXPORT___;
